<template>
  <div id="classDetailsDiv">
    <div class="classDetailsDiv_content">
      <div class="head_title class_head_title">
        <div class="head_title_font class_head_title_font">
          <span @click="cur=1;jumpToArrange()" :class="{active_table:cur=1}">作业安排</span>
        </div>
        <div class="head_title_font class_head_title_font" style="margin-left: 20px">
          <span @click="cur=0;jumpToScore()" :class="{active_table:cur=0}">作业成绩</span>
        </div>
      </div>

      <div class="body_content class_body_content">
        <div class="ifDiv">
          <div class="homework_left_div" >
            <ul id="myTab_two" class="nav nav-tabs">
              <li class="homework_one liClass" v-for="(schoolWorkOne,index) in schoolWorkList_" :key="index" :class="{active: current_index == index}" @click="current_index=index;initSchoolWorkList()">
                <a :href="schoolWorkOne.name" data-toggle="tab">
                  {{schoolWorkOne.type}}
                </a>
              </li>
            </ul>
            <!-- <ul id="myTab_two" class="nav nav-tabs">
               <li class="active homework_one liClass">
                 <a href="#one" data-toggle="tab">
                   理论教育
                 </a>
               </li>
               <li class="homework_two liClass">
                 <a href="#two" data-toggle="tab">
                   党性修养
                 </a>
               </li>
               <li class="homework_three liClass">
                 <a href="#three" data-toggle="tab">
                   调研报告
                 </a>
               </li>
               <li class="homework_four liClass">
                 <a href="#four" data-toggle="tab">
                   结业论文
                 </a>
               </li>
             </ul>-->
          </div>
          <div class="homework_right_div">
            <div id="myTabContent_two" class="tab-content">
              <div class="tab-pane fade in active" :id="schoolWorkList_[current_index].id">
                <div class="work_div">
                  <button type="button" class="btn btn-default btn_option homework_add " data-toggle="modal" data-target="#myModal_update" @click="homeworkOption='add'">+新增作业</button>
                  <table class="table table-striped table-bordered tbl_homework">
                    <thead>
                    <tr>
                      <th width="10%">作业名称</th>
                      <th width="15%">作业要求</th>
                      <th width="10%">提交截止时间</th>
                      <th width="15%">附件</th>
                      <th width="20%">已分配数/实际提交数/应提交数</th>
                      <th width="8%">未分配</th>
                      <th width="15%">操作</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(schoolWork,index) in schoolWorkList" :key="index">
                      <td width="10%">{{schoolWork.name}}</td>
                      <td  width="15%">{{schoolWork.summary}}</td>
                      <td width="10%">{{schoolWork.deadline}}</td>
                      <td width="15%">
                        <a @click="openPreviewModal(schoolWork.fileName, schoolWork.filePath)">{{schoolWork.fileName}}</a>
                      </td>
                      <td width="20%" :class="{font_read: schoolWork.schoolworkNum!=schoolWork.distribut}">
                        {{schoolWork.distribut}} / {{schoolWork.schoolworkNum }} / {{schoolWork.num}}
                      </td>
                      <td width="8%">{{schoolWork.schoolworkNum-schoolWork.distribut}}</td>
                      <td width="15%">
                        <div>
                          <div class="homework_edit" @click="editHomeworkId=schoolWork.schoolworkId;homeworkOption='update';getSchoolWorkById()"></div>
                          <div class="homework_delete" @click="editHomeworkId=schoolWork.schoolworkId;deleteSchoolWorkById(schoolWork.schoolworkNum)"></div>
                          <!--<div class="homework_edit_disabled" disabled v-else></div>-->
                        </div>
                        <button type="button" class="btn btn-default btn_option allot_btn" data-toggle="modal" data-target="#myModal"
                                @click="current_schoolWorkId=schoolWork.schoolworkId;current_schoolWorkName=schoolWork.name;checkbox.checkIds=[];initStudentWorkList(schoolWork.schoolworkId)">作业详情</button>
                        <!--:disabled="checkDate(schoolWork.deadline)"-->
                        <div class="homework_edit_two"></div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <!--查看单个作业的所有学员列表模态框-->
          <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
            <div class="modal-dialog disStudentsWork">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                    &times;
                  </button>
                  <h4 class="modal-title" id="myModalLabel">
                    分配批改作业
                  </h4>
                </div>
                <div class="modal-body">
                  <div v-if="classInfoEditFlag == 1">
                    <button type="button" class="btn btn-default homework_distribution" @click="allotTeacher()">分配批改教师</button>
                    <button type="button" class="btn btn-default homework_remind" @click="remindTeacher()" :disabled="canClickAgain">提醒批改</button>
                    <span v-show="canClickAgain" style="float: left;padding-top: 5px">{{timeNum}}s</span>

                    <input id="checkItBox" style="float: left;margin: 10px 0 0 10px" type="checkbox" @click="checkIt()">
                    <label for="checkItBox" style="float: left;margin: 8px 0 0 0px">未批改</label>

                    <!-- <button type="button" class="btn btn-default homework_remind" @click="showUploadModal()">上传作业</button>
                     <button type="button" class="btn btn-default homework_remind">批改作业</button>-->
                    <button type="button" class="btn btn-default btn_option"
                            style="height: 25px;line-height: 10px;float: right;margin-bottom: 5px;"
                            @click="exportHomeWork()">导出</button>
                  </div>
                  <table class="table table-striped table-bordered homework_table_details">
                    <thead>
                    <tr>
                      <th width="5%">序号</th>
                      <!-- <th width="173px">#</th>-->
                      <th width="5%"><input type="checkbox" @click="checkAll"></th>
                      <th width="10%">学员姓名</th>
                      <th width="25%">提交的作业</th>
                      <th width="10%">批改教师</th>
                      <!--<th>分配时间</th>-->
                      <th width="5%">评分</th>
                      <th width="30%">评语</th>
                      <th width="15%">操作</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(studentWorkOne,index) in studentSchoolWorkList" :key="index" v-show="(!checkItFlag) || (checkItFlag && !studentWorkOne.score)">
                      <td width="5%">{{index+1}}</td>
                      <td width="5%">
                        <input v-if="(!studentWorkOne.score && studentWorkOne.filePath)" name="list_item" type="checkbox" :checked="checkbox.checkIds.indexOf(studentWorkOne.id)>=0"
                               @click="checkedOne(studentWorkOne.id)">
                      </td>
                      <td width="10%">{{studentWorkOne.studentName}}</td>
                      <td width="25%">
                        <a @click="openPreviewModal(studentWorkOne.fileName, studentWorkOne.filePath)" class="break_all">{{studentWorkOne.fileName}}</a>
                        <a :href="hrefExport+studentWorkOne.filePath" v-if="studentWorkOne.filePath">下载</a>
                      </td>
                      <td width="10%">{{studentWorkOne.teacherName}}</td>

                      <!--分配时间暂时不写-->
                      <!--<td></td>-->

                      <!--评分-->
                      <td width="5%">{{studentWorkOne.score}}</td>

                      <!--评语-->
                      <td width="30%">{{studentWorkOne.remark}}</td>
                      <td width="15%">
                        <button type="button" class="btn btn-default btn_option allot_btn" @click="showUploadModal(studentWorkOne.studentId)">上传</button>
                        <button type="button" class="btn btn-default btn_option allot_btn" :disabled="!studentWorkOne.fileName" @click="showCheckModal(index)">批改</button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <!--  分配批改老师模态框-->
          <div class="modal fade" id="myModal_dis" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_dis" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content schoolWork_dis">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                    &times;
                  </button>
                  <h4 class="modal-title" id="myModalLabel_dis">
                    选择批改教师
                  </h4>
                </div>
                <div class="modal-body">
                  <!--<input type="text" placeholder="教师姓名" v-model="studentWorkInfo.teacherName">-->
                  <input class="form-control" type="text" placeholder="教师姓名" v-model="searchTeacherName" @keyup="loadQueryInputDataWhenAdd()">
                  <div id="teachers_div">
                    <option v-for="(queryData, index) in queryInputDataArr" :key="index" :value="queryData.userName"
                            @click="putTeacherData(index)">{{queryData.userName}}</option>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-default btn_save btn_dis" @click="distributionSchoolWork()">确定分配</button>
                    <button type="button" class="btn btn-default btn_cancel btn_dis" data-dismiss="modal">取消</button>
                  </div>
                </div>
              </div><!-- /.modal-content -->
            </div><!-- /.modal -->
          </div>

          <!--新增作业-->
          <div class="modal fade" id="myModal_update" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_update" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content content_work">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                    &times;
                  </button>
                  <h4 class="modal-title" id="myModalLabel_update">
                    {{homeworkOption=="add"?'新增作业':'修改作业'}}
                  </h4>
                </div>
                <div class="modal-body body_work">
                  <form role="form" class="homeworkArrange_form">
                    <input v-validate="'required|maxL:80'" data-vv-scope="homework" data-vv-as="作业名称" name="homeworkName" class="form-control" type="text" placeholder="输入作业名称" v-model="schoolWorkInfo.name">
                    <span class="spanRed">*</span>
                    <span class="validateTip">{{ errors.first('homework.homeworkName') }}</span>

                    <textarea v-validate="'required|maxL:300'" data-vv-scope="homework" data-vv-as="作业要求" name="homeworkSummary" class="form-control homeSummary" rows="" placeholder="输入作业要求" v-model="schoolWorkInfo.summary"></textarea>
                    <span class="spanRed homeSummary">*</span>
                    <span class="validateTip">{{ errors.first('homework.homeworkSummary') }}</span>

                    <input v-validate="'required'" data-vv-scope="homework" data-vv-as="提交作业截止时间" class="form-control" type="text" size="16" name="chooseDeadline" id="chooseDeadline" placeholder="选择提交截止时间" v-model="schoolWorkInfo.deadline" autocomplete="off">
                    <span class="spanRed">*</span>
                    <span class="validateTip">{{ errors.first('homework.chooseDeadline') }}</span>
                  </form>

                  <div class="editVideoDiv" v-if="(homeworkOption == 'update' && isUploadFile == true && isDeleteFile == false)">
                    <label>历史上传附件：</label>
                    <p class="fileListP">
                      <a @click="openVideoModal(schoolWorkInfo.filePath)">{{schoolWorkInfo.fileName}}</a>
                      <span title="删除" class="glyphicon glyphicon-remove" @click="deleteAttachmentsFile(schoolWorkInfo.attachmentId)"></span>
                    </p>
                  </div>

                  <uploader v-bind:class="{displayVideoUploadCom: (homeworkOption == 'update' && isUploadFile == true && isDeleteFile == false)}"
                            :options="upload.options" :file-status-text="upload.statusText" class="uploader-example" ref="uploader">
                    <uploader-unsupport></uploader-unsupport>
                    <uploader-drop>
                      <p>拖拽文件至此处</p>
                      <uploader-btn :attrs="upload.attrs.video">选择视频</uploader-btn>
                      <uploader-btn :attrs="upload.attrs.image">选择图片</uploader-btn>
                      <uploader-btn :attrs="upload.attrs.file">选择文件</uploader-btn>
                    </uploader-drop>
                    <uploader-list></uploader-list>
                  </uploader>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-default btn_save" v-on:click="modalClickOk()">
                    确认
                  </button>
                  <button type="button" class="btn btn-default btn_cancel" data-dismiss="modal">
                    取消
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!--分配批改——教务上传学员作业-->
          <div class="modal fade" id="myModal_upload" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_update" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content content_work">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                    &times;
                  </button>
                  <h4 class="modal-title" id="myModalLabel_upload">
                    上传学员作业
                  </h4>
                </div>
                <div class="modal-body body_work">
                  <!--    <form role="form" class="homeworkArrange_form">
                        <input v-validate="'required|maxL:80'" data-vv-scope="homework" data-vv-as="作业名称" name="homeworkName" class="form-control" type="text" placeholder="输入作业名称" v-model="schoolWorkInfo.name">
                        <span class="spanRed">*</span>
                        <span class="validateTip">{{ errors.first('homework.homeworkName') }}</span>
                      </form>-->
                  <div class="editVideoDiv" v-if="(homeworkOption == 'update' && isUploadFile == true && isDeleteFile == false)">
                    <label>历史上传附件：</label>
                    <p class="fileListP">
                      <a @click="openVideoModal(schoolWorkInfo.filePath)">{{schoolWorkInfo.fileName}}</a>
                      <span title="删除" class="glyphicon glyphicon-remove" @click="deleteAttachmentsFile(schoolWorkInfo.attachmentId)"></span>
                    </p>
                  </div>
                  <!--<uploader v-bind:class="{displayVideoUploadCom: (homeworkOption == 'update' && isUploadFile == true && isDeleteFile == false)}"
                            :options="upload.options" :file-status-text="upload.statusText" class="uploader-example" ref="uploadStu">
                    <uploader-unsupport></uploader-unsupport>
                    <uploader-drop style="text-align: center">
                      <p>拖拽作业文件至此处</p>
                      &lt;!&ndash;<uploader-btn :attrs="upload.attrs.video">选择视频</uploader-btn>&ndash;&gt;
                      &lt;!&ndash;<uploader-btn :attrs="upload.attrs.image">选择图片</uploader-btn>&ndash;&gt;
                      <uploader-btn :attrs="upload.attrs.file">选择文件</uploader-btn>
                    </uploader-drop>
                    <uploader-list></uploader-list>
                  </uploader>-->
                  <uploader :options="uploadStu.options" :file-status-text="uploadStu.statusText" class="uploader-example" ref="uploaderStu">
                    <uploader-unsupport></uploader-unsupport>
                    <uploader-drop>
                      <p>拖拽作业文件至此处</p>
                      <uploader-btn :attrs="uploadStu.attrs.file">选择文件</uploader-btn>
                      <uploader-btn :attrs="uploadStu.attrs.image">选择图片</uploader-btn>
                    </uploader-drop>
                    <uploader-list></uploader-list>
                  </uploader>

                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-default btn_save" v-on:click="">
                    确认
                  </button>
                  <button type="button" class="btn btn-default btn_cancel" data-dismiss="modal">
                    取消
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!--分配批改——教务批改学员作业-->
          <div class="modal fade" id="myModal_check" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_update" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content content_work">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                    &times;
                  </button>
                  <h4 class="modal-title" id="myModalLabel_check">
                    批改作业
                  </h4>
                </div>
                <div class="modal-body body_work">
                  <form role="form" class="homeworkArrange_form">
                    <input class="form-control" type="number" min="0" max="100" placeholder="输入评分" v-model="studentWorkInfo.score">
                    <textarea class="form-control" type="text" placeholder="输入评语" v-model="studentWorkInfo.remark" />
                  </form>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-default btn_save" v-on:click="updateScore()">
                    确认
                  </button>
                  <button type="button" class="btn btn-default btn_cancel" data-dismiss="modal">
                    取消
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!--图片显示-->
          <div class="modal fade" id="myModal_showAllImages" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_showAllImages" aria-hidden="true" data-backdrop='static'>
            <div class="modal-dialog modal-dialog_preview">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                    &times;
                  </button>
                  <h4 class="modal-title" id="myModalLabel_showAllImages">
                    图片预览
                  </h4>
                </div>
                <div class="modal-body modal-body_preview">
                  <img :src="imageSrc" class="previewImg"/>
                </div>
              </div>
            </div>
          </div>

          <!--视频显示-->
          <div class="modal fade" id="myModal_showVideo" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_showVideo" aria-hidden="true" data-backdrop='static'>
            <div class="modal-dialog modal-dialog_preview">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                    &times;
                  </button>
                  <h4 class="modal-title" id="myModalLabel_showVideo">
                    视频预览
                  </h4>
                </div>
                <div class="modal-body modal-body_preview">
                  <video class="showVideo video-js" :src="videoSrc" :type="videoType" controls="controls" controlslist="nodownload" autoplay="autoplay" loop="loop" :poster="videoThumbSrc">
                  </video>
                </div>
              </div>
            </div>
          </div>

          <!--文档显示-->
          <div class="modal fade" id="myModal_showFile" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_showFile" aria-hidden="true" data-backdrop='static'>
            <div class="modal-dialog modal-dialog_preview">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                    &times;
                  </button>
                  <h4 class="modal-title" id="myModalLabel_showFile">
                    文档预览
                  </h4>
                </div>
                <div class="modal-body modal-body_preview">
                  <iframe :src="fileSrc" width="100%" height="700px"></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {schoolAxios} from "../main";
  import {getContentSize} from './mainView';
  import dictionaryData from '../json/dictionary';

  export default {
    name: "homeworkManage",
    data() {
      return {
        clazzId: this.$store.state.clazzId,
        publishStatus: this.$store.state.publishStatus,
        classStatus: this.$store.state.classStatus,
        //是否可编辑flag
        classInfoEditFlag:this.$store.state.classInfoEditFlag,
        schoolWorkList: [],
        current_index: 0,
        schoolWorkList_: [
          {name: '#one', id:'one', type: '党性修养考核'},
          {name: '#two', id:'two', type: '知识能力考核'},
          {name: '#three', id:'three', type: '调研课题'},
          {name: '#four', id:'four', type: '结业论文'},
        ],
        studentSchoolWorkList:[],
        schoolWorkInfo: {
          id:'',
          name: '',
          summary: '',
          deadline: '',
          createTime:'',
          fileName:'',
          filePath: '',
          attachmentId: '',
        },

        homeworkOption: '',

        editHomeworkId: '',

        isUploadFile: false,
        isDeleteFile: false,
        //上传
        upload: {
          uploader: null,
          options: {
            target: this.$store.state.serviceBase + 'upload/chunkUpload.action',
            maxChunkRetries: 3,
            method: 'post',
            headers: {
              'Authorization': this.$store.state.token_type + " " + this.$store.state.access_token
            },
            /*query: {
              attachmentType: 'zy'
            },*/
            simultaneousUploads: 1,//同时上传数
            testChunks: false,
            chunkSize: 1024*1024,
            singleFile: true
          },
          attrs: {
            file: {
              accept: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword,application/pdf'
            },
            image: {
              accept: 'image/*'
            },
            video: {
              accept: 'video/*'
            },
          },
          statusText: {
            success: '成功了',
            error: '出错了',
            uploading: '上传中',
            paused: '暂停中',
            waiting: '等待中',
          },
        },

        //教务上传学员作业
        uploadStu: {
          uploader: null,
          options: {
            target: this.$store.state.serviceBase + 'studentSchoolwork/sswUpload.action',
            method: 'post',
            headers: {
              'Authorization': this.$store.state.token_type + " " + this.$store.state.access_token
            },
            query: {
              //studentId: this.$store.state.studentId
            },
            simultaneousUploads: 1,//同时上传数
            testChunks: false,
            chunkSize: 10*1024*1024*1024,//分片大小：10G
            singleFile: true,
          },
          attrs: {
            file: {
              accept: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword,application/pdf'
            },
            image: {
              accept: 'image/*'
            },
            /* video: {
               accept: 'video/!*'
             },*/
          },
          statusText: {
            success: '成功了',
            error: '出错了',
            uploading: '上传中',
            paused: '暂停中',
            waiting: '等待中',
          },
        },


        studentWorkInfo:{
          ids:'',
          teacherId:'',
          studentId:'',
          schoolworkId:'',
          createTime:'',
          score:'',
          teacherName:'',
          remark:'',
        },
        //上课教师搜索
        searchTeacherName: '',
        queryInputDataArr: [],

        checkbox: {
          checkIds: [],
        },

        current_schoolWorkId:'',
        current_schoolWorkName:'',

        currentStudent_schoolWorkId:'',

        //图片
        imageSrc: '',

        //视频
        videoSrc: '',
        videoThumbSrc: '',
        videoType: 'video/mp4',

        //文档
        fileSrc: '',
        canClickAgainData : {},
        canClickAgain: false,

        timeNum: '',

        checkItFlag: false,

        //作业安排与成绩切换flag
        cur:0,//默认选中第一个tab

        hrefExport:this.$store.state.serviceBase+"resources/",
      }
    },
    filters: {
      /* formatScore(value){
         let this_ = this;
         if(dictionaryData.school_score && value){
           value = dictionaryData.school_score[value];
         }
         return value;
       }*/
    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();
        this_.initSchoolWorkList();
        /* this_.initStudentWorkList();*/
        this_.closeModal();
        //日期
        this_.dateDefault();
        //获得上传组件对象
        this_.upload.uploader = this_.$refs.uploader.uploader;
        this_.uploadStu.uploader = this_.$refs.uploaderStu.uploader;
        //上传组件绑定事件
        this_.loadUpload();
        this_.loadUploadStu();
      });
    },
    methods: {
      /**
       * 加载作业列表
       */
      initSchoolWorkList(){
        let this_=this;
        schoolAxios({
          method: 'get',
          url: 'schoolwork/findSchoolHomeworkList',
          params:{
            "clazzId":this_.clazzId,
            "type": this_.schoolWorkList_[this_.current_index].type
          }
        }).then(function (response) {
          // console.info(response);
          let data = response.data;
          if(data.success){
            this_.schoolWorkList = data.list;
          }
        });
      },

      getSchoolWorkById(){
        let this_=this;
        schoolAxios({
          method:'get',
          url: 'schoolwork/load/'+this_.editHomeworkId,
          params:{}
        }).then(function (response) {
          let data = response.data;
          if(data.success){
            this_.schoolWorkInfo.id=data.data.id;
            this_.schoolWorkInfo.name=data.data.name;
            this_.schoolWorkInfo.summary=data.data.summary;
            this_.schoolWorkInfo.deadline=data.data.deadline;
            this_.schoolWorkInfo.fileName=data.data.fileName;
            this_.schoolWorkInfo.filePath=data.data.filePath;
            this_.schoolWorkInfo.attachmentId=data.data.attachmentId;

            //console.info(data.data.attachmentId,data.data.attachmentId && data.data.attachmentId!="");

            if(data.data.attachmentId && data.data.attachmentId!=""){
              this_.isUploadFile = true;
              this_.isDeleteFile = false;
            }else{
              this_.isUploadFile = false;
              this_.isDeleteFile = false;
            }

            $("#myModal_update").modal("show");
          }
        });
      },
      modalClickOk(){
        let this_ = this;
        if(this_.homeworkOption == 'add'){
          this_.addSchoolWork();
        }else {
          this_.updateSchoolWorkContent();
        }
      },
      addSchoolWork(){
        let this_=this;
        //if(this_.validateDataIsEmpty) {
        this_.$validator.validateAll('homework').then(result => {
          if (result) {
            schoolAxios({
              method: 'post',
              url: 'schoolwork/add',
              data: {
                'id': this_.schoolWorkInfo.id,
                'name': this_.schoolWorkInfo.name,
                'summary': this_.schoolWorkInfo.summary,
                'deadline': this_.schoolWorkInfo.deadline,
                "clazzId": this_.clazzId,
                "type": this_.schoolWorkList_[this_.current_index].type,
                "attachmentIds": this_.schoolWorkInfo.attachmentId
              }
            }).then(function (response) {
              // console.info(response);
              let data = response.data;
              if (data.success) {
                $("#myModal_update").modal("hide");
                "添加成功".showMessage();
                this_.initSchoolWorkList();
              } else {
                //"添加失败".showMessage();
                data.message.showMessage();
              }
            })
          }
        });
      },
      updateSchoolWorkContent(){
        let this_=this;
        this_.$validator.validateAll('homework').then(result => {
          if (result) {
            schoolAxios({
              method: 'put',
              url: 'schoolwork/edit',
              data: {
                'id': this_.schoolWorkInfo.id,
                'name': this_.schoolWorkInfo.name,
                'summary': this_.schoolWorkInfo.summary,
                'deadline': this_.schoolWorkInfo.deadline,
                "clazzId": this_.clazzId,
                "type": this_.schoolWorkList_[this_.current_index].type,
                "attachmentIds": this_.schoolWorkInfo.attachmentId
              }
            }).then(function (response) {
              // console.info(response);
              let data = response.data;
              if (data.success) {
                $("#myModal_update").modal("hide");
                "修改成功".showMessage();
                this_.initSchoolWorkList();
              } else {
                "修改失败".showMessage();
              }
            })
          }
        });
      },
      deleteAttachmentsFile(id){
        let this_ = this;
        "确定删除".showConfirm(function () {
          schoolAxios({
            method: 'delete',
            url: 'upload/delete.action',
            params: {
              uploadAttachmentId: id
            }
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              "删除成功".showMessage();
              this_.isUploadFile = false;
              this_.isDeleteFile = true;
              this_.upload.uploader.cancel();
            }else{
              "删除失败".showMessage();
            }
          })
        })
      },

      checkIt(){
        let this_ = this;
        if(this_.checkItFlag == true){
          this_.checkItFlag = false;
        }else {
          this_.checkItFlag = true;
        }
      },

      checkDate(date){
        let this_ = this;
        let date_now = new Date();
        date_now = date_now.getFullYear()+"-"+(date_now.getMonth() + 1)+"-"+date_now.getDate();
        date_now = new Date(date_now);
        let date_my = new Date(date);
        if(date_now.getTime() > date_my.getTime()){
          return false;
        }
        return true;
      },
      checkedOne (id) {
        let this_ = this;
        let idIndex = this_.checkbox.checkIds.indexOf(id);
        if (idIndex >= 0) {//如果已经包含就去除
          this_.checkbox.checkIds.splice(idIndex, 1);
        } else {//如果没有包含就添加
          this_.checkbox.checkIds.push(id);
        }
      },
      /*全选*/
      checkAll: function (e) {
        let this_ = this;
        let checked = e.target.checked;
        if(checked){
          this_.checkbox.checkIds=[];
          let studentSchoolWorkList = this_.studentSchoolWorkList;
          for(let i=0;i<studentSchoolWorkList.length;i++){
            let idIndex = this_.checkbox.checkIds.indexOf(studentSchoolWorkList[i].id);
            if (idIndex < 0) {//如果没有包含就添加
              this_.checkbox.checkIds.push(studentSchoolWorkList[i].id);
            }
          }
        }else{
          this_.checkbox.checkIds=[];
        }
        let element = document.querySelectorAll("input[name=list_item]");
        element.forEach((item) => {
          item.checked = checked;
        });
      },
      allotTeacher(){
        let this_ = this;
        if(this_.checkbox.checkIds.length == 0){
          $("#myModal_dis").modal("hide");
          "请选择作业进行分配".showMessage();
        }
        else {
          $("#myModal_dis").modal("show");
        }
        /*this_.checkbox.checkIds.push("22");
        this_.checkbox.checkIds.push("33");
        this_.checkbox.checkIds.push("44");
        this_.checkbox.checkIds.push("55");
        console.info(this_.checkbox.checkIds.join(','),this_.checkbox.checkIds.toString());*/
      },
      /*加载单个作业所有学员作业记录*/
      initStudentWorkList(id){
        let this_=this;
        schoolAxios({
          method: 'get',
          url: 'studentSchoolwork/findList',
          params:{
            "schoolworkId": id,
            "clazzId":this_.clazzId,
          }
        }).then(function (response) {
          console.info(response);
          let data = response.data;
          if(data.success) {
            this_.studentWorkInfo.schoolworkId = id;
            this_.studentSchoolWorkList = data.list;

            if (!this_.canClickAgainData[id]) {
              this_.canClickAgainData[id] = {};
              this_.canClickAgainData[id].disabled = false;
              this_.canClickAgainData[id].timeNum = 180;
            }
            this_.canClickAgain = this_.canClickAgainData[id].disabled;
            this_.timeNum = this_.canClickAgainData[id].timeNum;

          }
        });
      },
      /*分配批改老师*/
      distributionSchoolWork(){
        let this_=this;
        /*this_.ids=JSON.stringify();*/
        if(this_.checkbox.checkIds.length==0){
          return false;
        }
        if(this_.studentWorkInfo.teacherId == ""){
          "该教师不存在".showMessage();
          return false;
        }
        schoolAxios({
          method: 'put',
          url: 'studentSchoolwork/editTeacher',
          data:{
            "ids":this_.checkbox.checkIds.toString(),
            "schoolworkId":this_.studentWorkInfo.schoolworkId,
            "teacherId":this_.studentWorkInfo.teacherId,
            "teacherName":this_.studentWorkInfo.teacherName
          },
        }).then(function (response) {
          console.info(response);
          let data = response.data;
          if(data.success){
            /* "分配成功".showMessage();*/
            this_.studentSchoolWorkList = data.list;
            this_.initSchoolWorkList();
          } else {
            "分配失败".showMessage();
          }
          $("#myModal_dis").modal("hide");
          $("#myModal").modal("hide");
        });
      },

      /*提醒批改*/
      remindTeacher(){
        let this_ = this;
        schoolAxios({
          url: 'studentSchoolwork/remindTeacher',
          data: {
            schoolworkId: this_.current_schoolWorkId,
            schoolWorkName: this_.current_schoolWorkName
          }
        }).then(function (response) {
          console.info(response);
          let data = response.data;
          if(data.success){
            let id = this_.current_schoolWorkId;
            // "提醒成功".showMessage();
            //定时执行
            this_.canClickAgainData[this_.current_schoolWorkId].disabled = true;
            this_.canClickAgain = true;

            let t1 = window.setTimeout(function () {
              this_.canClickAgainData[id].disabled = false;
              this_.canClickAgain = false;
              window.clearTimeout(t1);
            }, 1000 * 180);
            let t2 = window.setInterval(function () {
              this_.canClickAgainData[id].timeNum -= 1;
              if(this_.canClickAgainData[id].timeNum == 0){
                this_.canClickAgainData[id].timeNum = 180;
                window.clearInterval(t2);
              }
              if(id == this_.current_schoolWorkId)
                this_.timeNum = this_.canClickAgainData[id].timeNum;
            }, 1000);

          } else {
            data.message.showMessage();
          }
        });
      },

      /**
       * 联想查询班主任信息-add
       */
      loadQueryInputDataWhenAdd(){
        let this_ = this;
        if(this_.searchTeacherName != ""){
          //后台查询数据赋值
          schoolAxios({
            method: 'get',
            url: 'user/queryUserSchoolByUserName',
            params: {
              'userName': this_.searchTeacherName
            }
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              this_.queryInputDataArr = data.list;
              $("#teachers_div").show();
            }
          });
        }else{
          this_.queryInputDataArr= [];
        }
      },
      putTeacherData(index){
        let this_ = this;
        if(index >= 0){
          let data = this_.queryInputDataArr[index];

          this_.studentWorkInfo.teacherId = data.id;
          this_.studentWorkInfo.teacherName = data.userName;

          this_.searchTeacherName = data.userName;
          $("#teachers_div").hide();
        }
      },

      /**
       * 教务人员手动上传学员作业
       */
      showUploadModal(studentId){
        let this_ = this;
        this_.uploadStu.options.query.schoolworkId = this_.current_schoolWorkId;
        this_.uploadStu.options.query.studentId = studentId;
        $("#myModal_upload").modal("show");
      },
      /**
       * 获取批改作业弹窗
       */
      showCheckModal(index){
        let this_ = this;
        let my_data = this_.studentSchoolWorkList[index];
        this_.studentWorkInfo.score = my_data.score;
        this_.studentWorkInfo.remark = my_data.remark;
        this_.studentWorkInfo.id = my_data.id;
        $("#myModal_check").modal("show");
      },
      /**
       *  教务人员批改学员作业
       */
      updateScore(){
        let this_ = this;
        schoolAxios({
          method: 'put',
          url: 'studentSchoolwork/editScoreAndRemark',
          data: {
            id: this_.studentWorkInfo.id,
            score: this_.studentWorkInfo.score,
            remark:  this_.studentWorkInfo.remark
          }
        }).then(function (resp) {
          let data = resp.data;
          if(data.success){
            this_.initStudentWorkList(this_.current_schoolWorkId);
            "保存成功".showMessage();
            $("#myModal_check").modal("hide");
          }else {
            data.message.showMessage();
          }
        });
      },


      loadUpload(){
        let this_ = this;
        this_.upload.uploader.on('fileAdded', function (file, event) {
          /*if(this_.schoolWorkInfo.attachmentId != ""){
            "只允许上传一次附件".showMessage();
            return false;
          }*/
          if(file.fileType.indexOf("video")==-1 && file.fileType.indexOf("image")==-1 && this_.upload.attrs.file.accept.indexOf(file.fileType)==-1){
            (file.name+"不是所需格式文件，请重新选择正确的格式文件上传").showMessage();
            return false;
          }
        })
        this_.upload.uploader.on('fileSuccess', function (rootFile, file, message, chunk) {
          if(message){
            let message_ = JSON.parse(message);

            //目前只允许提交一个附件，所以附件ID为空
            this_.schoolWorkInfo.attachmentId = "";

            if(this_.schoolWorkInfo.attachmentId != ""){
              this_.schoolWorkInfo.attachmentId += ",";
            }
            this_.schoolWorkInfo.attachmentId += message_.message;
          }
        })
        this_.upload.uploader.on('fileComplete', function (rootFile) {
          console.info(rootFile);
        })
        this_.upload.uploader.on('fileError', function (rootFile, file, message) {
          (file.name+"上传失败").showMessage();
        })
      },


      /**
       * 导出作业
       */
      exportHomeWork(){
        let this_=this;
        schoolAxios({
          method: 'get',
          url:'studentSchoolwork/exportStudentsWorkList',
          params: {
            "clazzId":this_.clazzId,
            schoolworkId:this_.current_schoolWorkId
          }
        }).then(function (response) {
          location.href=this_.hrefExport+response.data.data;
        });
      },



      loadUploadStu(){
        let this_ = this;
        this_.uploadStu.uploader.on('fileAdded', function (file, event) {
          if(this_.uploadStu.attrs.file.accept.indexOf(file.fileType)==-1 && file.fileType.indexOf("image")==-1){
            (file.name+"不是所需格式文件，请重新选择正确的格式文件上传").showMessage();
            return false;
          }
        })
        this_.uploadStu.uploader.on('fileSuccess', function (rootFile, file, message, chunk) {
          if(message){
            let message_ = JSON.parse(message);
            if(message_.success){
              message_.message.showMessage();
              this_.initStudentWorkList(this_.current_schoolWorkId);
              $("#myModal_upload").modal("hide");
              this_.uploadStu.uploader.cancel();
            }else {
              message_.message.showMessage();
            }
          }
        })
        this_.uploadStu.uploader.on('fileComplete', function (rootFile) {
          //console.info(rootFile);
        })
        this_.uploadStu.uploader.on('fileError', function (rootFile, file, message) {
          (file.name+"上传失败").showMessage();
        })
      },
      /**
       * 初始化日期选择框
       */
      dateDefault(){
        let this_ = this;
        let date, nowDate;
        date = new Date();
        nowDate = date.getFullYear() + "-";
        nowDate += (date.getMonth() + 1) + "-";
        nowDate += date.getDate() + " ";
        this_.timeDate = nowDate;
        $('#chooseDeadline').datetimepicker({
          minView: "month",//选择日期后，不会再跳转去选择时分秒
          language: 'zh-CN',
          format: 'yyyy-mm-dd',
          //startDate: this_.timeDate,
          weekStart: 0,
          todayBtn: true,
          clearBtn: true,
          autoclose: true,//选择一个日期后是否立即关闭此选择框
          todayHighlight: true,//高亮当前日期
          startView: 2,// 日期时间选择器打开之后首先显示的视图，默认值为：2，0:hour,1:day,2:mouth,3:year,4:decade
          forceParse: 0,
          showMeridian: 1,
          startDate:new Date(),
        }).on('hide', function (ev) {
          let value = $("#chooseDeadline").val();
          this_.schoolWorkInfo.deadline = value;

          ev.preventDefault();
          ev.stopPropagation();
        });
      },
      deleteSchoolWorkById(num){
        if(num > 0){
          "学员已提交作业，不能删除".showMessage();
          return;
        }
        let this_=this;
        "确定删除".showConfirm(function () {
          schoolAxios({
            method: 'delete',
            url: 'schoolwork/delete/' + this_.editHomeworkId,
            params: {}
          }).then(function (response) {
            this_.initSchoolWorkList();
          });
        })
      },

      /**
       * 打开预览模态框
       */
      openPreviewModal(fileName, filePath) {
        let this_ = this;

        let suffix = fileName.substring(fileName.indexOf('.')+1);

        if("mp4".indexOf(suffix)!=-1){
          this_.videoSrc = this_.$store.state.serviceBase + "resources/" + filePath;
          $("#myModal_showVideo").modal("show");
        }else if("doc,docx,pdf".indexOf(suffix)!=-1) {
          let data = filePath.substring(0, 11);
          let fileId = filePath.substring(11, filePath.indexOf('.'));
          this_.fileSrc = this_.$store.state.serviceBase + "resources/" + data + fileId + "_file/" + fileId + ".html";
          $("#myModal_showFile").modal("show");
        }else {
          this_.imageSrc = this_.$store.state.serviceBase + "resources/" + filePath;
          $("#myModal_showAllImages").modal("show");
        }
      },
      /**
       * 关闭模态框监听
       */
      closeModal() {
        let this_ = this;
        $('#myModal_update').on('hide.bs.modal', function () {
          this_.schoolWorkInfo = {
            id:'',
            name: '',
            summary: '',
            deadline: '',
            createTime: '',
            fileName: '',
            filePath: '',
            attachmentId: '',
          };
          this_.isUploadFile = false;
          this_.isDeleteFile = false;
          this_.upload.uploader.cancel();
          this_.uploadStu.uploader.cancel();

          setTimeout(function () {
            this_.errors.clear('homework');
          });

        });
        $('#myModal_showVideo').on('hide.bs.modal', function () {
          this_.videoSrc = "";
        });
        /* $('#myModal_update').on('hide.bs.modal', function () {
           this_.schoolWorkInfo.fileName = "";
           this_.imageSrc = "";
         });*/
      },
      /**
       * 作业安排作业成绩tab切换
       */
      jumpToArrange(){
        let this_ = this;
        //路由跳转
        this_.$router.push({
          name: 'HomeworkManage',
        });
      },
      jumpToScore(){
        let this_ = this;
        this_.$router.push({
          name: 'HomeworkScore',
        });
      }
    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  .head_title_font {
    border: none;
  }
  .class_head_title_font {
    width: 80px;
    cursor: pointer;
  }
  .active_table {
    /*background-color: #ff6f66;*/
    color: #ff6f66;
    padding-bottom: 8px;
    border-bottom: 3px solid #ff6f66;
  }
  .table {
    color: #FFFFFF;
  }
  .table th {
    color: black;
    background-color: #cccccc;
  }
  .table tr{
    color: black;
    background-color: #FFFFFF;
  }
  .table th {
    text-align: center;
  }
  .table td {
    text-align: center;
    line-height: 28px;
  }
  /*分配批改作业列表表格样式*/
  /*.tbl_homework {
    table-layout: fixed;
    text-align: center;
  }
  .table-striped {
    background-color: #FFFFFF;
  }

  .tbl_homework th {
    height: 40px;
    text-align: center;
    color: black;
    background-color: #CCCCCC;
  }
  .tbl_homework td {
    height: 40px;
  }*/

  .tbl_homework tr td {
    word-wrap: break-word;
  }
  /*分配批改作业模态框列表表格样式*/
  .homework_table_details {
    /*table-layout: fixed;
    text-align: center;*/
  }
  .homework_table_details th {
    /*height: 40px;*/
    text-align: center;
    color: black;
    background-color: #CCCCCC;
  }
  .homework_table_details td {
    height: 40px;
  }
  .homework_table_details tr td {
    /*word-wrap: break-word;*/
  }
  /*分配批改模态框列表表头固定*/
  .homework_table_details thead tr{
    display: table;
    width: 100%;
    table-layout: fixed;
  }

  .homework_table_details tbody{
/*    display: block;*/
    width: 100%;
    height: 450px;
    /*overflow-y: scroll;*/
    overflow: auto;
  }
  .homework_table_details tbody tr{
    display: table;
    width: 100%;
    table-layout: fixed;
  }
  .homework_table_details{
    border: none;
  }
  .homework_table_details tbody::-webkit-scrollbar{
    width:0;
  }
  .ifDiv {
    height: 100%;
    width: 100%;
  }
  ul li {
    clear: left;
  }
  .tab-content {
    /* margin: 0 0 0 15%;*/
    /*background-color: #C9C9C9;*/
  }
  .tab-pane {
    padding: 45px 36px 0 36px;
  }
  .homework_left_div {
    position: absolute;
    left: 0;
    top: 4%;
    width: 14%;
    height: 92%;
  }
  .homework_right_div {
    position: absolute;
    left: 14%;
    top: 4%;
    width: 86%;
    height: 92%;
    /*background-color: #C9C9C9;*/
    border: 1px #ccc solid;
  }
  .liClass {
    margin: 15px 0px;
    width: 160px;
    height: 40px;
    font-size: 15px;
    border-radius: 5px;
  }
  .liClass a {
    color: black;
    cursor: default;
  }
  .nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover :after{
    color: black;
    cursor: default;
    background-color: #ff6f66;
    color: #fff;
    border: 0px;
    /*border-bottom: 2px black solid;*/
    border-radius: 5px;
  }
  /*.nav-tabs>li.active>a:focus:after{
   background-image: url("../img/right/homeworkArrange/homework_left_pic.png");
  }*/
  button.btn.btn-default.btn_option.allot_btn {
    background-color: #ff6f66;
  }
  .disStudentsWork {
    width: 65%;
  }/*
.modal-content {
  !*height: 350px;*!
}
.modal-title {
  text-align: center;
}
.modal-body {
  text-align: center;
}
.modal-footer {
  text-align: center;
  margin: 40px 0 0 0;
}
.btn_save, .btn_cancel{
  width:15%;
  height: 40px;
}*/
  .homework_distribution,.homework_remind {
    color: black;
    float: left;
    margin: 0 0 10px 0;
  }
  .homework_remind {
    margin: 0 0 0 20px;
  }
  .modal-content.schoolWork_dis {
    width: 350px;
    height: 20%;
    margin: 10% 0 0 30%;
  }
  .btn_dis {
    width: 100px;
    margin: 20px 0 0 0;
  }
  #teachers_div {
    position: absolute;
    left: 15px;
    width: 92%;
    border: 1px grey solid;
    background-color: white;
    display: none;
  }
  #teachers_div option {
    height: 30px;
    line-height: 30px;
    text-align: left;
  }
  #teachers_div option:hover {
    background-color: grey;
  }
  .work_div {
    height: 60%;
  }
  .previewImg {
    max-width: 100%;
  }
  .modal-body_preview {
    text-align: center;
  }
  .modal-dialog_preview {
    width: 60%;
  }
  .font_read {
    color: #C9744F;
  }
  .nav-tabs {
    border-bottom: 0px solid #ddd;
  }
  /*分配批改列表表头固定*/
  .tbl_homework thead tr{
    display: table;
    width: 100%;
    table-layout: fixed;
  }
  .tbl_homework tbody{
    display: block;
    height: 400px;
    /*overflow-y: scroll;*/
    overflow: auto;
  }
  .tbl_homework tbody tr{
    display: table;
    width: 100%;
    table-layout: fixed;
  }
  .tbl_homework{
    border: none;
  }
  .tbl_homework tbody::-webkit-scrollbar{
    width:0;
  }
  .homework_add {
    height: 33px;
    width: 140px;
    border-radius: 5px;
    margin: 0 0 30px 0;
    font-size: 15px;
  }
  .homework_edit {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/clazz/edit.png");
    background-size: 100% 100%;
    float: left;
    margin: 0 5px 0 5px;
  }
  .homework_edit_disabled {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/clazz/edit_disabled.png");
    background-size: 100% 100%;
    float: left;
    margin: 0 5px 0 5px;
  }
  .homework_delete {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/clazz/delete.png");
    background-size: 100% 100%;
    float: left;
  }
  .homework_delete:hover{
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/clazz/delete_mouseOver.png");
    background-size: 100% 100%;
  }
  .homeworkArrange_form input{
    width: 100%;
    height: 32px;
    margin: 10px 0;
  }
  input.form-control,textarea {
    display: inline-block;
    width: 97%;
  }
  span.spanRed.homeSummary {
    position: absolute;
    top: 17%;
    right:2.5%;
  }
  textarea.form-control.homeSummary {
    margin: 0 15px 0 0;
  }
  textarea {
    /*width: 100%;*/
    height: 100px;
    resize:none;
    margin: 0 0 0 0;
  }
  .content_work {
    /*height: 500px;*/
  }
  .body_work {
    height: 75%;
  }
  .displayVideoUploadCom {
    display: none;
  }
  .editVideoDiv {
    text-align: left;
    margin-bottom: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/components/homeworkManage.vue